<div fxLayout="column" *ngIf="!activeEmailTemplateDocument; else emailTemplateEditor">
  <app-page-header [section]="'Atoku'" [title]="'Booking Config'"
    [description]="'Configure booking buffers and company booking settings.'"></app-page-header>

  <div class="page-padding page-content full-screen-height-page-default" fxLayout="column">
    <form [formGroup]="form" fxLayout="column">

      <!-- Booking Rules -->
      <div fxLayout="column" fxLayoutGap="16px">
        <div fxLayout="row" fxFlexOffset="20px">
          <span class="subtitle-default">Booking Rules</span>
          <button fxFlexOffset="30px" class="button-action" mat-flat-button
                  (click)="save()"
                  [disabled]="(loader.loading$ | async) || form.invalid || form.pristine">
            <div class="button-text">Save</div>
          </button>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="16px" fxFlexOffset="15px">
          <mat-form-field class="custom-text-field" appearance="outline">
            <mat-label>Buffer Time (hours)</mat-label>
            <input matInput type="number" formControlName="bufferTimeHours" min="1" max="8">
            <mat-hint>Maintenance/cleaning time after any booking</mat-hint>
            <mat-error class="link-error" *ngIf="form.get('bufferTimeHours')?.hasError('min')">Minimum is 1 hour</mat-error>
            <mat-error class="link-error" *ngIf="form.get('bufferTimeHours')?.hasError('max')">Maximum is 8 hours</mat-error>
          </mat-form-field>

          <mat-form-field class="custom-text-field" appearance="outline">
            <mat-label>Maximum Lead Time (hours)</mat-label>
            <input matInput type="number" formControlName="maximumLeadTimeHours" min="1">
            <mat-hint>Handled in BE: how long before booking users can create it</mat-hint>
            <mat-error class="link-error" *ngIf="form.get('maximumLeadTimeHours')?.hasError('min')">Minimum is 1 hour</mat-error>
          </mat-form-field>

          <mat-form-field class="custom-text-field" appearance="outline">
            <mat-label>Allowed Team Members</mat-label>
            <input matInput type="number" formControlName="allowedTeamMembers" min="0">
            <mat-hint>Additional members allowed per card</mat-hint>
            <mat-error class="link-error" *ngIf="form.get('allowedTeamMembers')?.hasError('min')">Minimum is 0</mat-error>
          </mat-form-field>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="24px" fxFlexOffset="8px">
          <mat-checkbox formControlName="allowAdditionalMembersToRequestAccess">
            Additional members can request access
          </mat-checkbox>

          <mat-checkbox formControlName="allowAdditionalMembersToShareWithTeam">
            Additional members can share with team
          </mat-checkbox>
        </div>

        <div fxLayout="column" fxLayoutGap="12px" fxFlexOffset="18px">
          <span class="subtitle-default">Refund Rules</span>

          <div fxLayout="row wrap" fxLayoutGap="16px" fxLayoutAlign="start center">
            <mat-form-field class="custom-text-field" appearance="outline">
              <mat-label>Refund Fine Time Frame (hours)</mat-label>
              <input matInput type="number" formControlName="refundMinimumNoticeHours" min="0">
              <mat-hint>Fine applies when cancelling within this many hours before the booking</mat-hint>
              <mat-error class="link-error" *ngIf="form.get('refundMinimumNoticeHours')?.hasError('min')">Minimum is 0 hours</mat-error>
            </mat-form-field>

            <mat-button-toggle-group class="custom-labeled-button-toggle" formControlName="lateCancellationFeeAmountType">
              <mat-button-toggle value="fixed">Fixed Rand</mat-button-toggle>
              <mat-button-toggle value="percentage">Percentage</mat-button-toggle>
            </mat-button-toggle-group>

            <mat-form-field class="custom-text-field" appearance="outline">
              <mat-label>Refund Fine Amount</mat-label>
              <span matPrefix *ngIf="form.get('lateCancellationFeeAmountType')?.value !== 'percentage'">R&nbsp;</span>
              <input matInput type="number" formControlName="lateCancellationFeeAmount" min="0" step="0.01">
              <span matSuffix *ngIf="form.get('lateCancellationFeeAmountType')?.value === 'percentage'">%&nbsp;</span>
              <mat-hint>Fixed rand value or percentage of the cancelled booking</mat-hint>
              <mat-error class="link-error" *ngIf="form.get('lateCancellationFeeAmount')?.hasError('min')">Minimum is 0</mat-error>
              <mat-error class="link-error" *ngIf="form.get('lateCancellationFeeAmount')?.hasError('max')">Maximum is 100%</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="column" fxLayoutGap="12px" fxFlexOffset="18px">
          <span class="subtitle-default">Deposit Rules</span>

          <div fxLayout="row wrap" fxLayoutGap="16px" fxLayoutAlign="start center">
            <mat-button-toggle-group class="custom-labeled-button-toggle" formControlName="requiredDepositAmountType">
              <mat-button-toggle value="fixed">Fixed Rand</mat-button-toggle>
              <mat-button-toggle value="percentage">Percentage</mat-button-toggle>
            </mat-button-toggle-group>

            <mat-form-field class="custom-text-field" appearance="outline">
              <mat-label>Required Deposit Amount</mat-label>
              <span matPrefix *ngIf="form.get('requiredDepositAmountType')?.value !== 'percentage'">R&nbsp;</span>
              <input matInput type="number" formControlName="requiredDepositAmount" min="0" step="0.01">
              <span matSuffix *ngIf="form.get('requiredDepositAmountType')?.value === 'percentage'">%&nbsp;</span>
              <mat-error class="link-error" *ngIf="form.get('requiredDepositAmount')?.hasError('min')">Minimum is 0</mat-error>
              <mat-error class="link-error" *ngIf="form.get('requiredDepositAmount')?.hasError('max')">Maximum is 100%</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Company Info -->
      <div fxLayout="column" fxLayoutGap="16px" fxFlexOffset="30px">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlexOffset="10px">
          <span class="subtitle-default">Company Info</span>
          <button fxFlexOffset="30px" class="button-action" mat-flat-button
                  (click)="save()"
                  [disabled]="(loader.loading$ | async) || form.invalid || form.pristine">
            <div class="button-text">Save</div>
          </button>
        </div>

        <div class="terms-actions" fxLayout="column" fxLayoutGap="12px">
          <div fxLayout="column" fxLayoutGap="4px">
            <span class="body-1-regular-2">Booking Documents</span>
            <span class="body-2-regular-2">Configure client-facing text and email templates.</span>
          </div>

          <div fxLayout="row wrap" fxLayoutGap="10px">
            <button class="button-action" mat-flat-button type="button"
              [disabled]="termsLoading || termsSaving"
              (click)="openTermsAndConditions()">
              <mat-icon>{{ termsLoading || termsSaving ? 'hourglass_empty' : 'description' }}</mat-icon>
              <div class="button-text">{{ termsButtonText }}</div>
            </button>

            <button class="button-action" mat-flat-button type="button"
              [disabled]="emailTemplateLoading !== null || emailTemplateSaving !== null"
              (click)="openEmailTemplate('approvalEmail', 'Approval Email')">
              <mat-icon>{{ emailTemplateLoading === 'approvalEmail' || emailTemplateSaving === 'approvalEmail' ? 'hourglass_empty' : 'mark_email_read' }}</mat-icon>
              <div class="button-text">{{ approvalEmailButtonText }}</div>
            </button>

            <button class="button-action" mat-flat-button type="button"
              [disabled]="emailTemplateLoading !== null || emailTemplateSaving !== null"
              (click)="openEmailTemplate('bookingConfirmationEmail', 'Booking Confirmation Email')">
              <mat-icon>{{ emailTemplateLoading === 'bookingConfirmationEmail' || emailTemplateSaving === 'bookingConfirmationEmail' ? 'hourglass_empty' : 'forward_to_inbox' }}</mat-icon>
              <div class="button-text">{{ confirmationEmailButtonText }}</div>
            </button>
          </div>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="16px">
          <mat-form-field fxFlex="0 1 260px" class="custom-text-autofill" appearance="outline" floatLabel="always">
            <mat-label>Company ID</mat-label>
            <input matInput formControlName="companyId" readonly>
          </mat-form-field>

          <mat-form-field fxFlex="0 1 300px" class="custom-text-autofill" appearance="outline" floatLabel="always">
            <mat-label>Name</mat-label>
            <input matInput formControlName="companyName" readonly>
          </mat-form-field>
        </div>

        <mat-form-field class="custom-text-area booking-text-area" appearance="outline" floatLabel="always">
          <mat-label>Offer Text (Access Pass)</mat-label>
          <textarea matInput formControlName="offerTextAccessPass" rows="4"
            placeholder="Max 10 words"></textarea>
          <mat-hint align="end">{{ offerWordCount }}/10 words</mat-hint>
          <mat-error class="link-error" *ngIf="form.get('offerTextAccessPass')?.hasError('required')">Offer text is required</mat-error>
          <mat-error class="link-error" *ngIf="form.get('offerTextAccessPass')?.hasError('maxWords')">Maximum 10 words</mat-error>
        </mat-form-field>

        <div fxLayout="row wrap" fxLayoutGap="16px">
          <mat-form-field class="custom-text-field booking-standard-field" appearance="outline" floatLabel="always">
            <mat-label>Signup Route (Access Pass)</mat-label>
            <input matInput formControlName="signupRouteAccessPass">
            <mat-hint>Editable</mat-hint>
            <mat-error class="link-error" *ngIf="form.get('signupRouteAccessPass')?.hasError('required')">Signup route is required</mat-error>
          </mat-form-field>

          <mat-form-field class="custom-text-autofill booking-standard-field" appearance="outline" floatLabel="always">
            <mat-label>Allowed Card Types</mat-label>
            <input matInput formControlName="allowedCardTypes" readonly>
          </mat-form-field>

          <mat-form-field class="custom-text-autofill booking-standard-field" appearance="outline" floatLabel="always">
            <mat-label>Client Reference Format</mat-label>
            <input matInput formControlName="clientReferenceFormat" readonly>
          </mat-form-field>
        </div>
      </div>

      <!-- Ops Team SMS -->
      <div fxLayout="column" fxLayoutGap="16px" fxFlexOffset="30px">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlexOffset="10px">
          <span class="subtitle-default">Ops Team SMS</span>
        </div>

        <div class="ops-notifications-panel" fxLayout="column" fxLayoutGap="14px">
          <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="12px">
            <span class="body-2-regular-2">Store the cellphone numbers used for operational SMS alerts.</span>

            <mat-slide-toggle color="primary" formControlName="smsNotificationsEnabled">
              SMS Notifications
            </mat-slide-toggle>
          </div>

          <div formArrayName="opsTeamCellphoneNumbers" fxLayout="column" fxLayoutGap="10px">
            <div class="ops-number-row" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="start center"
              fxLayoutAlign.lt-sm="start stretch" fxLayoutGap="10px"
              *ngFor="let control of opsTeamCellphoneNumbers.controls; let i = index; trackBy: trackByIndex">
              <mat-form-field class="custom-text-field ops-number-field" appearance="outline" floatLabel="always">
                <mat-label>Cellphone Number</mat-label>
                <input matInput [formControlName]="i" placeholder="+27 82 123 4567">
                <mat-error class="link-error" *ngIf="control.hasError('cellphoneNumber')">Enter a valid cellphone number</mat-error>
              </mat-form-field>

              <button mat-icon-button type="button" aria-label="Remove cellphone number"
                (click)="removeOpsTeamCellphoneNumber(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>

          <div *ngIf="opsTeamCellphoneNumbers.length === 0" class="ops-empty-state">
            No Ops team cellphone numbers added.
          </div>

          <div fxLayout="row" fxLayoutAlign="start center">
            <button mat-stroked-button type="button" class="button-action subtle-action"
              (click)="addOpsTeamCellphoneNumber()">
              <mat-icon>add</mat-icon>
              <div class="button-text">Add Cellphone Number</div>
            </button>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>

<ng-template #emailTemplateEditor>
  <div fxLayout="column" fxLayoutGap="20px" class="email-template-editor-page">
    <app-page-header
      [section]="'Atoku'"
      [title]="activeEmailTemplateTitle"
      [description]="'Edit the email content and layout.'">
    </app-page-header>

    <mat-sidenav-container class="sidenav-container body-1-regular-2 atoku-email-editor-container">
      <mat-sidenav mode="side" opened position="start" class="sidenav-left atoku-email-editor-sidenav"
        [fixedInViewport]="false" [fixedTopGap]="0" [fixedBottomGap]="0">
        <div class="sidenav-left-content template-left-content" fxLayout="column" fxLayoutGap="18px">
          <div fxLayout="row">
            <span class="currently-selected-template-icon" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
              <mat-icon class="material-symbols-outlined">edit_notifications</mat-icon>
              <span class="heading-default">{{ activeEmailTemplateTitle }}</span>
            </span>
          </div>

          <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="end center">
            <button (click)="closeEmailTemplateEditor()"
              [disabled]="emailTemplateSaving !== null"
              class="button-action-cancel" mat-flat-button>
              <div class="button-text">Back</div>
            </button>
            <button (click)="saveActiveEmailTemplate()"
              [disabled]="emailTemplateSaving !== null"
              class="button-action" mat-flat-button>
              <div class="button-text">{{ emailTemplateSaving ? 'Saving' : 'Update' }}</div>
            </button>
          </div>

          <div fxLayout="row">
            Edit the raw HTML used for this email and verify the rendered result before saving.
          </div>

          <div fxLayout="column" fxLayoutGap="12px" [formGroup]="emailTemplateForm">
            <div class="body-1-default">Template Details</div>

            <mat-form-field appearance="outline" class="custom-text-field full-width" floatLabel="always">
              <mat-label>Template Name</mat-label>
              <input matInput formControlName="name">
            </mat-form-field>

            <mat-form-field appearance="outline" class="custom-text-field full-width" floatLabel="always">
              <mat-label>Email Subject</mat-label>
              <input matInput formControlName="subject">
            </mat-form-field>

            <mat-form-field appearance="outline" class="custom-text-field full-width" floatLabel="always">
              <mat-label>Preview Text</mat-label>
              <input matInput formControlName="previewText">
            </mat-form-field>
          </div>

          <div fxLayout="column" fxLayoutGap="8px">
            <div class="body-1-default">Document Status</div>
            <div>{{ activeEmailTemplateDocument?.companyName }}</div>
            <div class="body-2-regular-2">{{ activeEmailTemplateStatus }}</div>
            <div class="body-2-regular-2" *ngIf="activeEmailTemplateDocument?.documentId">
              {{ activeEmailTemplateDocument?.documentId }}
            </div>
          </div>
        </div>
      </mat-sidenav>

      <mat-sidenav-content cdkScrollable class="sidenav-main-content">
        <div class="content-padding atoku-email-source-shell" [formGroup]="emailTemplateForm">
          <mat-tab-group animationDuration="0ms">
            <mat-tab label="HTML">
              <div class="atoku-email-tab-content">
                <mat-form-field appearance="outline" class="custom-text-area full-width atoku-email-html-field" floatLabel="always">
                  <mat-label>Email HTML</mat-label>
                  <textarea
                    matInput
                    formControlName="html"
                    spellcheck="false"
                    wrap="off"
                    rows="28"
                    placeholder="Paste or edit the final email HTML here.">
                  </textarea>
                </mat-form-field>
              </div>
            </mat-tab>

            <mat-tab label="Compiled view">
              <div class="atoku-email-tab-content">
                <div class="atoku-email-preview-shell">
                  <iframe
                    class="atoku-email-preview-frame"
                    [srcdoc]="compiledEmailPreviewHtml">
                  </iframe>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</ng-template>
